/*
 * Recent searches
 * ---------------------------------------------------------------------------
 * The last few things this shopper searched for, shown as chips in the search
 * panel when the box is empty, under "Popular searches" and the quick links.
 * A returning visitor on a 9,000-product store is usually back for the same
 * thing; one tap beats retyping it on a phone.
 *
 * Everything lives in the shopper's own browser (localStorage, six terms,
 * newest first). Nothing is sent anywhere, and "Clear" forgets the lot, which
 * matters on a site people share devices to visit.
 *
 * What counts as a search: submitting any form with role="search" (the header
 * box, the phone-menu field, the "See all N results" button), or tapping a
 * chip inside one (a popular search or a query suggestion). A recent chip is a
 * plain link to the results page, but when the browser can, tapping it fills
 * the box and submits the form instead, so it goes through the same path as
 * typing: the search-term map in sections/header.liquid still sends
 * "fleshlight" to Strokers.
 *
 * The header renders the block:
 *
 *   <div data-recent-searches data-search-url="/search" hidden>
 *     ... <button data-recent-clear> ...
 *     <ul data-recent-list></ul>
 *   </div>
 *
 * and this fills it. No block on the page, nothing runs.
 */
(function () {
  'use strict';

  var KEY = 'suzies:recent-searches';
  var MAX = 6;
  var MIN_LENGTH = 2;
  var MAX_LENGTH = 60;
  var BOX = '[data-recent-searches]';
  var LIST = '[data-recent-list]';
  var CLEAR = '[data-recent-clear]';
  var CHIP = 'a.search-bar__chip';
  var FORM = 'form[role="search"]';

  function storage() {
    try { return window.localStorage; } catch (e) { return null; }
  }

  function read() {
    var store = storage();
    if (!store) return [];
    var list;
    try { list = JSON.parse(store.getItem(KEY) || '[]'); } catch (e) { return []; }
    if (!(list instanceof Array)) return [];
    var out = [];
    for (var i = 0; i < list.length && out.length < MAX; i++) {
      if (typeof list[i] === 'string' && list[i]) out.push(list[i]);
    }
    return out;
  }

  function write(list) {
    var store = storage();
    if (!store) return;
    try {
      if (list.length) store.setItem(KEY, JSON.stringify(list));
      else store.removeItem(KEY);
    } catch (e) { /* private mode, quota: the chips just do not persist */ }
  }

  function clean(term) {
    return String(term == null ? '' : term).replace(/\s+/g, ' ').trim();
  }

  function remember(term) {
    term = clean(term);
    if (term.length < MIN_LENGTH || term.length > MAX_LENGTH) return read();
    var lower = term.toLowerCase();
    var list = [term];
    var old = read();
    for (var i = 0; i < old.length; i++) {
      if (old[i].toLowerCase() !== lower) list.push(old[i]);
    }
    list = list.slice(0, MAX);
    write(list);
    render();
    return list;
  }

  function clear() {
    write([]);
    render();
  }

  function escape(text) {
    return text.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function chip(term, searchUrl) {
    return '<li><a href="' + escape(searchUrl) + '?q=' + encodeURIComponent(term) +
      '&amp;type=product&amp;options%5Bprefix%5D=last" class="search-bar__chip" data-recent-term>' +
      escape(term) + '</a></li>';
  }

  function render() {
    var boxes = document.querySelectorAll(BOX);
    var list = read();
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var ul = box.querySelector(LIST);
      var url = box.getAttribute('data-search-url') || '/search';
      var html = '';
      for (var j = 0; j < list.length; j++) html += chip(list[j], url);
      if (ul) ul.innerHTML = html;
      box.hidden = list.length === 0;
    }
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.getAttribute || form.getAttribute('role') !== 'search') return;
    var input = form.querySelector('input[name="q"]');
    if (input) remember(input.value);
  }

  function onClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest(CLEAR)) {
      event.preventDefault();
      clear();
      return;
    }

    var link = target.closest(CHIP);
    if (!link) return;
    var form = link.closest(FORM);
    if (!form) return;
    var term = clean(link.textContent);

    if (link.hasAttribute('data-recent-term') && typeof form.requestSubmit === 'function') {
      var input = form.querySelector('input[name="q"]');
      if (input) {
        event.preventDefault();
        input.value = term;
        form.requestSubmit();
        return;
      }
    }
    remember(term);
  }

  function boot() {
    if (!document.querySelector(BOX)) return;
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('click', onClick, true);
    render();
  }

  window.theme = window.theme || {};
  window.theme.recentSearches = { read: read, remember: remember, clear: clear, render: render, key: KEY, max: MAX };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
